import { mergeDeepRight } from 'ramda';

/**
 * Apply barber shop data updates to the barberDataByShopId object
 * @param barberDataByShopId - e.g. { '1': { shopId: '1', name: 'Joe', ... }, '2': { shopId: '2', name: 'Joe', ... } }
 * @param shopUpdatesArray - e.g. [{ shopId: 1, name: 'Jane' }, { shopId: 2, name: 'Jane'}]
 * @returns updated barberDataByShopId
 */
// eslint-disable-next-line import/prefer-default-export
export const applyBrandBarberUpdate = (barberDataByShopId, shopUpdatesArray) => {
  if (!shopUpdatesArray || !shopUpdatesArray.length || !barberDataByShopId) {
    return barberDataByShopId;
  }

  const newBarberDataByShopId = { ...barberDataByShopId };
  shopUpdatesArray.forEach((shopUpdate) => {
    if (newBarberDataByShopId[shopUpdate.shopId]) {
      newBarberDataByShopId[shopUpdate.shopId] = mergeDeepRight(newBarberDataByShopId[shopUpdate.shopId], shopUpdate);
    }
  });
  return newBarberDataByShopId;
};
